import React, { useEffect, useState } from "react";

import { FilterListCheckbox } from "@app/scripts/reactify/filters/FilterListCheckbox";
import { FilterListSwatch } from "@app/scripts/reactify/filters/FilterListSwatch";
import { FilterSortDrawerItem } from "@app/scripts/reactify/filters/FilterSortDrawerItem";

import type { FilterListProps, Swatches } from "@app/scripts/types";

export const FilterList: React.FC<FilterListProps> = (props) => {
  const [swatches, setSwatches] = useState<Swatches>([]);
  const [checked, setChecked] = useState(0);

  useEffect(() => {
    try {
      const script = document.querySelector("[data-swatchesjson]");
      if (!script) {
        return console.error("No JSON swatch script found");
      }
      const json = JSON.parse(script.innerText.replace("\n", ""));
      setSwatches(json);
    } catch (e) {
      console.error("JSON error", e);
    }

    for (const option of props.filterListProps.options) {
      if (option.checked) {
        setChecked(checked + 1);
      }
    }
  }, []);

  useEffect(() => {
    window.selectedFilters = {
      ...(window.selectedFilters || {}),
      [props?.filter?.handle]: props?.filterListProps?.totalSelected || 0
    }

    const activeFilters = document.querySelectorAll(".active-filters")
    if (activeFilters?.length) {
      activeFilters?.forEach((item) => item.innerHTML = `(${Object.values<any>(window.selectedFilters).reduce((sum: number, value: number) => sum + value, 0)})`)
    }
  }, [props?.filterListProps?.totalSelected])

  return (
    <FilterSortDrawerItem
      id={props.filter.id}
      title={props.filter.name}
      checked={!!props.filterListProps.totalSelected}
      amountChecked={checked}
    >
      <div className="rs__filter">
        {props.filter.displayView === "list" ? <FilterListCheckbox {...props} className="rs__list" /> : null}
        {props.filter.displayView === "check" ? <FilterListCheckbox {...props} className="rs__check" /> : null}
        {props.filter.displayView === "swatch" ? (
          <FilterListSwatch {...props} swatches={swatches} className="rs__swatch" />
        ) : null}
        {props.filter.displayView === "box" ? <FilterListCheckbox {...props} className="rs__box" /> : null}
      </div>
    </FilterSortDrawerItem>
  );
};
